const EXPOSABLE_ERROR_PATTERNS = [
  "maximum number of versions",
  "maximum limit",
  "Duplicate",
  "already exists",
  "cannot be renamed",
  "Cannot move document",
];

export function getDocumentErrorMessage(error: any, fallback: string): string {
  if (error?.status === 400 && error?.data?.message) {
    const msg = error.data.message;
    if (EXPOSABLE_ERROR_PATTERNS.some((pattern) => msg.includes(pattern))) {
      return msg;
    }
  }
  return fallback;
}
